module.exports = __webpack_public_path__ + "img/LUB00281.2871a994.png";